import client from "client/client";
import {
    HostedScriptsRolloutResource,
    HostedScriptsVersionResource
} from "client/resources/hostedScriptsRolloutResource";
import { UpdateHostedScriptsVersionNotesRequest } from "client/resources/updateHostedScriptsVersionNotesRequest";
import { PagingResource } from "client/resources/pagingResource";
import { ListArgs } from "./listArgs";

export default class HostedScriptsRepository {

    private versionsUri = "/api/hosted-scripts-versions";
    private rolloutsUri = "/api/hosted-scripts-rollouts";

    listVersions(args?: ListArgs): Promise<PagingResource<HostedScriptsVersionResource>> {
        return client.get(`${this.versionsUri}{?skip,take}`, {...args});
    }

    updateVersionNotes(version: string, request: UpdateHostedScriptsVersionNotesRequest) {
        return client.put(`${this.versionsUri}/{version}`, request, {version});
    }

    listRollouts(args: { versions?: string[], reefId?: string }): Promise<HostedScriptsRolloutResource[]> {
        return client.get(`${this.rolloutsUri}{?versions,reefId}`, {
            versions: args.versions?.join(","),
            reefId: args.reefId,
        });
    }
}
